import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, requireMattress = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#2b3134] text-white/70 text-sm">
        Caricamento…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    requireMattress &&
    (!user.mattresses || user.mattresses.length === 0) &&
    !location.pathname.startsWith("/onboarding")
  ) {
    return <Navigate to="/onboarding/add-mattress" replace />;
  }

  return children;
}
